import axios from 'axios';
import { HIDELIST_CONTRACTS } from '../../constants/hidelist-contracts';
import { INFT } from '../../types/nft';

export type ReservoirApiGetByWalletProps = (
  account: string,
  assetCallback: (assets: INFT[]) => void,
  chainId?: number,
  offset?: number,
) => Promise<void>;

export const getNFTsByWallet: ReservoirApiGetByWalletProps = async (
  account,
  assetCallback,
  chainId,
  offset = 0,
): Promise<void> => {
  const reservoirApiKey = process.env.REACT_APP_RESERVOIR_API_KEY;
  const limit = 50;
  const headers = { headers: { accept: '*/*', 'x-api-key': reservoirApiKey } };
  const url = `https://api${
    chainId === 5 ? '-goerli' : ''
  }.reservoir.tools/users/${account}/tokens/v5?sortBy=acquiredAt&sortDirection=desc&offset=${
    offset ?? 0
  }&limit=${limit}&includeTopBid=false`;

  axios
    .get<ReservoirApiDto>(url, headers)
    .then(async (res) => {
      if (res.data.tokens.length > 0) {
        assetCallback(
          res.data.tokens
            .filter(
              (nft) =>
                // filter NFTs created with OS collection manager, reason - https://github.com/niftyhorde/swap-kiwi-frontend/issues/202
                !HIDELIST_CONTRACTS.includes(nft.token.contract),
            )
            .map(
              (nft): INFT => {
                return {
                  id: `${nft.token.tokenId}-${nft.token.contract}`,
                  contractAddress: nft.token.contract,
                  tokenId: nft.token.tokenId,
                  name: nft.token.name,
                  issuer: nft.token.collection.name,
                  imgUrl: nft.token.image,
                  amount: nft.ownership.tokenCount.toString(),
                  openseaUrl: `https://${chainId !== 1 ? 'testnets.' : ''}opensea.io/assets/ethereum/${
                    nft.token.contract
                  }/${nft.token.tokenId}`,
                  type: '',
                };
              },
            ),
        );
        // recursively call this function to get the next batch of nfts offsetting the previous amount
        getNFTsByWallet(account, assetCallback, chainId, offset + limit);
      } else {
        assetCallback([]);
      }
    })
    .catch((err) => console.log('Reservoir api call failed', err));
};

interface ReservoirApiDto {
  tokens: tokenDto[];
}

interface tokenDto {
  token: {
    contract: string;
    tokenId: string;
    name: string;
    image: string;
    collection: {
      id: string;
      name: string;
      imageUrl: string;
      floorAskPrice: number;
    };
  };
  ownership: {
    tokenCount: number;
    onSaleCount: number;
    floorAsk?: {
      id: string;
      price?: {
        currency: {
          contract: string;
          name: string;
          symbol: string;
          decimals: number;
        };
        amount: {
          raw: string;
          decimal: number;
          usd: number;
          native: 0.025;
        };
      };
      maker?: string;
      validFrom: string;
      validUntil: string;
      source?: {
        id: string;
        domain: string;
        name: string;
        icon: string;
        url: string;
      };
    };
  };
  acquiredAt: string;
}
